import { TAssessRiskProfile } from "@assetmark/risk-components/dist/models/assessRiskProfile.model";
import { TQuestionData } from "@assetmark/risk-components/dist/models/riskQuestion.model";
import { TInvestmentReturn } from "../models/investment-return.model";
import { TRiskQuestion } from "../models/risk-question.model";
import { currencyFormatter } from "./formathelper";

export const GetSideBarMenuItem = () => {};

export const getInvestmentReturnModels = (
	data: TAssessRiskProfile[],
	investmentAmount: number,
	profileId: number
) => {
	const invReturn =  data.map((ret, index) => {
		if (ret.gainLoss) {
			return {
				Key: index + 1,
				Gain: investmentAmount + (investmentAmount * ret.gainLoss.gainPercent) / 100,
				GainPercent: ret.gainLoss.gainPercent,
				Loss: investmentAmount + (investmentAmount * ret.gainLoss.lossPercent) / 100,
				LossPercent: ret.gainLoss.lossPercent,
				AverageReturn: investmentAmount + (investmentAmount * ret.gainLoss.longTermAveragePercent) / 100,
				AverageReturnPercent: ret.gainLoss.longTermAveragePercent,
			};
		} else {
			return {
				Key: index + 1,
				Gain: investmentAmount + investmentAmount / 100,
				GainPercent: 0,
				Loss: investmentAmount + investmentAmount / 100,
				LossPercent: 0,
				AverageReturn: investmentAmount + investmentAmount / 100,
				AverageReturnPercent: 0,
			};
		}
	});

	return invReturn.find(inv => inv.Key === profileId) || {
		Key: 0,
		Gain: 0,
		GainPercent: 0,
		Loss: 0,
		LossPercent: 0,
		AverageReturn: 0,
		AverageReturnPercent: 0,
	};
};

//TQuestionData
export const getQuestionsDataBySequesnce = (heading: string, sequence: number, data: Array<TRiskQuestion>): TQuestionData => {
	const questionObject = data.find(item => item.sequence === sequence) || {
		questionId: 0,
		sequence: sequence,
		question: '',
		choices: [],
		selectedChoiceId: 0,
	};

	return { ...questionObject, heading };
};

export const getInvestmentText = (
	investmentInfo: TQuestionData,
	invesetmentRangeData: TAssessRiskProfile[],
	amount: number,
): string => {
	if (investmentInfo.selectedChoiceId) {
		const selectedChoiceIndex = investmentInfo.choices.findIndex(a => a.choiceId === investmentInfo.selectedChoiceId);
		if (selectedChoiceIndex > -1) {
			const gainPercent = invesetmentRangeData[selectedChoiceIndex].gainLoss.gainPercent;
			const lossPercent = invesetmentRangeData[selectedChoiceIndex].gainLoss.lossPercent;
			const profit = amount + (amount * gainPercent) / 100;
			const loss = amount + (amount * lossPercent) / 100;
			return `$${currencyFormatter(loss)} to $${currencyFormatter(profit)}`;
		}
	}
	return '';
};

export const countMaxDecline = (InvestmentAmount: number, percentage: number) => {
	return (Math.abs(percentage) * InvestmentAmount) / 100;
};

export const formatLabel = (Amount: number) => {
	return '-$' + currencyFormatter(Amount);
};

export const getMaximumDeclineText = (questionData: TQuestionData, amount: number) => {
    const selectedChoice = questionData.choices.find(a => a.choiceId === questionData.selectedChoiceId);
    if(selectedChoice) {
        return formatLabel(countMaxDecline(amount, parseFloat(selectedChoice.choice)));
    }
    return '';
};

export const getStockMarketText = (questionData: TQuestionData) => {
    const selectedChoice = questionData.choices.find(a => a.choiceId === questionData.selectedChoiceId);
    if(selectedChoice) {
        return selectedChoice.choice;
    }
    return '';
};

export const getAgeRangeText = (questionData: TQuestionData) => {
    const selectedChoice = questionData.choices.find(a => a.choiceId === questionData.selectedChoiceId);
    if(selectedChoice) {
        return selectedChoice.choice;
    }
    return '';
};

export const getPlannedWithdrawalText = (questionData: TQuestionData) => {
    const selectedChoice = questionData.choices.find(a => a.choiceId === questionData.selectedChoiceId);
    if(selectedChoice) {
        return selectedChoice.choice;
    }
    return '';
};

export const getSelectedAgeId = (ageRange: TQuestionData, age: number) => {
    const ageChoices = ageRange.choices || {};
	if (Object.keys(ageChoices).length) {
		if (age < 50) {
			return ageChoices[0].choiceId;
		} else if (age >= 50 && age < 60) {
			return ageChoices[1].choiceId;
		} else if (age >= 60 && age < 70) {
			return ageChoices[2].choiceId;
		} else if (age >= 70 && age < 80) {
			return ageChoices[3].choiceId;
		} else {
			return ageChoices[4].choiceId;
		}
	}

    return 0;
};